import { projectInuseDetailAtom } from '@/state/atom/projectAtom';
import { getUserListByProjectAtom } from '@/state/atom/userAtom';
import { isManagerByProjectInuseSelector } from '@/state/selector/projectSelector';
import React from 'react';
import { useRecoilValue } from 'recoil';
import MenuMasterKnowledgeTagInPutBase from './MenuMasterKnowledgeTagInPutBase';
import { getListActiveB2BCustomerSelector, getListActiveB2BHelpdeskSelector } from '@/state/selector/ticketSelector';

export default function MenuMasterKnowledgeTagInPutWithAuthen(props) {
    const projectDetail = useRecoilValue(projectInuseDetailAtom);
    const isProjectManager = useRecoilValue(isManagerByProjectInuseSelector);
    let userListOfProject = useRecoilValue(getUserListByProjectAtom);
    const b2bCustomerList = useRecoilValue(getListActiveB2BCustomerSelector)
    const b2bSupportList = useRecoilValue(getListActiveB2BHelpdeskSelector)

    return (
        <MenuMasterKnowledgeTagInPutBase
            {...props}
            projectDetail={projectDetail}
            isProjectManager={isProjectManager}
            userListOfProject={userListOfProject}
            b2bCustomerList={b2bCustomerList}
            b2bSupportList={b2bSupportList}
        />
    );
}
